import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = (ModalService, $translate, $scope, $stateParams, $q, PolicyService) => {
    const ctrl = Object.create(BaseCtrl);
    ctrl.init = () => {
        $scope.policyNumber = $stateParams.policyNumber;
        ctrl.getNotes();
    };

    ctrl.getNotes = () => {
        const notesRequest = PolicyService.getNotesForPolicy($stateParams.policyNumber);
        $scope.notesRequest = notesRequest;

        $q.when(
            notesRequest,
            (notes) => {
                $scope.notes = notes;
            },
            () => {
                const msg = $translate(
                    'gateway.views.policy-detail.notes.error',
                    {policyNumber: $stateParams.policyNumber}
                );
                ModalService.showError('gateway.views.modal.Error', msg);
            }
        );
    };

    return ctrl.create($scope);
};
fn.$inject = ['ModalService', '$translate', '$scope', '$stateParams', '$q', 'PolicyService'];

export default fn;
